import styled from '@emotion/styled';
import { Col } from 'antd';

export const ToggleButtonsContainer = styled(Col)`
  display: flex;
  justify-content: flex-end;
  margin-bottom: 32px;
`;

export const ToggleButton = styled.div`
  background-color: ${props => (props.isToggled ? props.theme.color.primary : props.theme.color.white)};
  border: 1px solid;
  border-color: ${props => props.theme.color.primary};
  border-radius: 40px;
  color: ${props => (props.isToggled ? props.theme.color.white : props.theme.color.primary)};
  cursor: pointer;
  font-size: 24px;
  line-height: 56px;
  height: 56px;
  width: 56px;
  text-align: center;

  &:first-of-type {
    margin-right: 4px;
  }

  &:hover {
    color: ${props => props.theme.color.white};
    background-color: ${props => props.theme.color.primary};
  }
`;
